export enum InputFieldTypes {
  text = 'text',
  select = 'select',
  datePicker = 'datePicker',
  multiselect = 'multiselect',
}

type CommonInputProps = {
  value: string
  setValue: (value: string) => void
  disabled?: boolean
  children?: React.ReactNode
  labelParams?: LabelParams
}

export type TextInputProps = CommonInputProps & React.InputHTMLAttributes<HTMLInputElement> & {
  type: InputFieldTypes.text
}

export type SelectOptions = {
  value: string
  label: string
}

export type SelectInputProps = CommonInputProps & {
  type: InputFieldTypes.select
  options: Array<SelectOptions>
}

export type DatepickerValue = {
  start: string
  end: string
}

export type DatePickerProps = Omit<CommonInputProps, 'value' | 'setValue'> & {
  type: InputFieldTypes.datePicker
  value: DatepickerValue
  setValue: (value: DatepickerValue) => void
  calendarYearRange?: number
}

export type MultiSelectProps = Omit<CommonInputProps, 'value' | 'setValue'> & {
  type: InputFieldTypes.multiselect
  options: Array<SelectOptions>
  value: Array<string>
  setValue: React.Dispatch<React.SetStateAction<Array<string>>>
}

export type LabelParams = {
  i18nTag: string
  onClean?: () => void
}

export type InputProps = (TextInputProps | SelectInputProps | DatePickerProps | MultiSelectProps)